export enum HTTPMethod {
	Get = 'GET',
	Post = 'POST',
	Delete = 'DELETE',
	Options = 'OPTIONS',
	Put = 'PUT',
	Patch = 'PATCH',
}
